import React from 'react';
import DownloadButton from 'modules/common/components/buttons/downloadButton';
import SnackbarWrapper from 'modules/common/components/snackbars/snackbarWrapper';
import ToolboxButton from 'modules/users/components/toolboxButton';
import UserInsightsBlock from 'modules/insights/components/userInsightsBlock';
import { CurrentUserSettings } from 'modules/settings';
import { messagingApi, reportsApi } from 'api/instances';

interface ComponentProps { 
    navigateToSettings: () => any;
    userMobileStats: UserMobileStats;
    currentUser: CurrentUserSettings;
}

interface UserMobileStats {
    activeDevices: number,
    usersWithApp: number,
    usersWithNoDevice: number
}

const MessagingCenterMobileTab: React.FunctionComponent<ComponentProps> = ({navigateToSettings, userMobileStats, currentUser}) =>  {

    const defaultStyles: React.CSSProperties = {
        height: '50px',
        lineHeight: '0px',
        width: '290px',
        textAlign: 'left',
        boxShadow: '0 0 5px #b8b8b8',
        margin: 5,
        borderRadius: 5,
        border: 'none',
        cursor: 'pointer',
        background: 'white',
        color: 'black'
    }

    const [successMessage, setSuccessMessage] = React.useState<string>("");
    const [errorMessage, setErrorMessage] = React.useState<string>("");

    const getSuccessMessage = (): string => `Your report is being generated and will be emailed to ${currentUser?.email} when it's ready.`;
    const getErrorMessage = (): string => `Something went wrong. Please try again.`;

    const onReportSuccess = () => setSuccessMessage(getSuccessMessage());
    const onReportError = () => setErrorMessage(getErrorMessage());

    const sendMobileDataReportRequest = async () => {
        try {
            await reportsApi.SendMobileUserDataReportRequest();
            onReportSuccess();
        }
        catch (error) {
            onReportError();
        }
    }

    return (
        <div className="messaging-center-tab-container">
            <h4>Mobile App User Count</h4>
            <div className="email-tab-container">
                <div className="center-div">

                    <div className="vertically-center-div">
                        <div className="email-insights">
                            
                            <UserInsightsBlock 
                                title={"Total Number of Active Devices"}
                                stats={userMobileStats.activeDevices}
                            />

                            <UserInsightsBlock 
                                title={"Total Number of Users With App"}
                                stats={userMobileStats.usersWithApp}
                            />

                            <UserInsightsBlock 
                                title={"Total Number of Users With No Device"}
                                stats={userMobileStats.usersWithNoDevice}
                            />
                        </div>
                    </div>

                    <div className="email-toolbox-container">
                        <span className="toolbox-title">Mobile App Toolbox</span>
                        <div className="toolbox-button-wrapper">    
                            <DownloadButton
                                onClick={sendMobileDataReportRequest}
                                text={" Download User Data"}
                                styles={defaultStyles}
                            />

                            <DownloadButton
                                onClick={() => messagingApi.GetOutbox("mobile") }
                                text={" Download Mobile App Outbox"}
                                downloadName={`notification-mobile-outbox-user-data`}
                                styles={defaultStyles}
                            />

                            <ToolboxButton 
                                title={"Automated Mobile App Configurations"}
                                handleClick={() => navigateToSettings()}    
                            />
                            
                        </div>
                    </div>
                </div>
            </div>
            <SnackbarWrapper open={!!successMessage} style={{ top: "60px" }} autoHideDuration={8000} onClose={() => setSuccessMessage("")} severity="success" message={successMessage} />
            <SnackbarWrapper open={!!errorMessage} style={{ top: "60px" }} autoHideDuration={8000} onClose={() => setErrorMessage("")} severity="error" message={errorMessage} />
        </div>
    )
}

export default MessagingCenterMobileTab;